export default angular
    .module('westBerkshireEvents.ticketNumberingFilter', [])
    .name;


// WEBPACK FOOTER //
// src/public/javascripts/ticket-numbering-filter/ticket_numbering.module.js